module.exports = __webpack_public_path__ + "img/bitcoin.o.4634eec9.png";